import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import MyAccount from 'layouts/MyAccount';
import { Title, Grid, Nav, NavTab, PlanSection } from './styles';
import BannerMyAccount from 'components/BannerMyAccount';
import getCleverTap from 'utils/clevertap';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  title: PropTypes.string,
  tabItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  children: PropTypes.node.isRequired,
};

export default function MyAccountTabs({ title, tabItems, children }) {
  const router = useRouter();
  const { user } = useAuthUser();
  const clevertap = getCleverTap();

  function handleEvent(label) {
    clevertap.event.push('Clicks to view information detail', {
      Product: 'MTG',
      Email: user.email,
      'Country code': user.country_code,
      URL: router.asPath,
      Description: `${label} click`,
    });
  }

  return (
    <MyAccount>
      <Head>
        <title>Profile - My Account - Mind The Graph</title>
      </Head>
      <Grid>
        <Nav title="Navigation menu">
          {tabItems.map((tabItem) => (
            <NextLink key={tabItem.label} href={tabItem.path} passHref>
              <NavTab
                onClick={() => handleEvent(tabItem.label)}
                isActive={router.asPath === tabItem.path}
              >
                {tabItem.label}
              </NavTab>
            </NextLink>
          ))}

          <BannerMyAccount />
        </Nav>

        <PlanSection>
          {title && <Title>{title}</Title>}
          {children}
        </PlanSection>
      </Grid>
    </MyAccount>
  );
}

MyAccountTabs.propTypes = Props;
